export default __webpack_public_path__ + "static/SRUS SPL4 - Product Specifications & Technical Data-f2e909555c0466022be10ec0fc7cd8d6.pdf";